(() => {
  if (window.__asapFormLeadReady || window.Shopify?.designMode) return;
  window.__asapFormLeadReady = true;
  const storageKey = 'asap_meta_lead_pending_v1';
  let timer;
  let attempts = 0;
  const readPending = () => {
    try { return JSON.parse(sessionStorage.getItem(storageKey) || 'null'); }
    catch (_) { return null; }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const type = form.querySelector('input[name="form_type"]')?.value;
    if (!['contact', 'customer'].includes(type)) return;
    if (!form.querySelector('[name="contact[email]"]') || !form.checkValidity()) return;
    const pending = { id: form.id, type, path: location.pathname, time: Date.now() };
    try { sessionStorage.setItem(storageKey, JSON.stringify(pending)); } catch (_) {}
  }, true);
  const onConfirmedSuccess = () => {
    const pending = readPending();
    if (!pending || pending.path !== location.pathname || Date.now() - pending.time > 1800000) return;
    const success = Array.from(document.querySelectorAll('[data-asap-lead-success]')).some(marker =>
      marker.dataset.formId === pending.id && marker.dataset.formType === pending.type
    );
    if (!success) return;
    if (typeof window.fbq !== 'function') {
      if (++attempts <= 60) timer = setTimeout(onConfirmedSuccess, 500);
      return;
    }
    try {
      fbq('track', 'Lead');
      sessionStorage.removeItem(storageKey);
      clearTimeout(timer);
    } catch (_) {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onConfirmedSuccess, { once: true });
  else onConfirmedSuccess();
})();
